"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApdexEventType = exports.ApdexEventName = void 0;
var ApdexEventName;
(function (ApdexEventName) {
    ApdexEventName["IN_PROJECT_SEARCH"] = "in-project-search";
    ApdexEventName["DASHBOARD_SEARCH"] = "dashboard-search";
    ApdexEventName["TM_GET_SUGGESTIONS"] = "tm-get-suggestions";
    ApdexEventName["GLOSSARY_GET_SUGGESTIONS"] = "glossary-get-suggestions";
    ApdexEventName["MT_GET_SUGGESTIONS"] = "mt-get-suggestions";
    ApdexEventName["CONFIRMED_STATUS_UPDATE_ON_TRANSLATION_SAVE"] = "confirmed-status-update-on-translation-save";
    ApdexEventName["CONFIRMED_STATUS_UPDATE_ON_ICON_CLICK"] = "confirmed-status-update-on-icon-click-translation-save";
})(ApdexEventName || (ApdexEventName = {}));
exports.ApdexEventName = ApdexEventName;
var ApdexEventType;
(function (ApdexEventType) {
    ApdexEventType["BEGIN"] = "begin";
    ApdexEventType["SEND_REQUEST"] = "send-request";
    ApdexEventType["RESPONSE_RECEIVED"] = "response-received";
    ApdexEventType["RENDERED"] = "rendered";
})(ApdexEventType || (ApdexEventType = {}));
exports.ApdexEventType = ApdexEventType;
